import { isolateComponent, labelStyles, withModifier, } from '@zapier/style-encapsulation';
import { Link } from '../../navigation/Link';
import { Colors, Typography } from '../../../theme';
const Styles = labelStyles('MenuItem', {
    content: (props) => [
        Object.assign(Object.assign({}, Typography.paragraph3Medium), { alignItems: 'center', borderRadius: 3, color: Colors.neutral700, display: 'flex', height: 44, lineHeight: '44px', padding: '0 10px', textDecoration: 'none', outline: 'none', width: '100%', '&:not([disabled]):hover, &:not([disabled]):focus': {
                backgroundColor: Colors.blue10,
                color: Colors.blue,
                fontWeight: props.isSelected ? 600 : 500,
            }, '&[disabled]': {
                color: Colors.neutral500,
                cursor: 'not-allowed',
            } }),
        props.isSelected &&
            withModifier('selected', {
                backgroundColor: Colors.neutral200,
                fontWeight: 600,
            }),
    ],
    text: {
        flex: 1,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
    },
});
export const MenuItem = (props) => {
    const Tag = props.href && !props.disabled ? Link : 'button';
    const isLink = Tag === Link;
    const ariaLabel = props.isSelected
        ? `${props.ariaLabel || props.children}, selected`
        : props.ariaLabel;
    const conditionalProps = isLink
        ? {
            ariaLabel,
            href: props.href,
            rel: props.rel,
        }
        : {
            'aria-label': ariaLabel,
            type: 'button',
            disabled: props.disabled,
        };
    const liRole = props.role ? { role: 'none' } : null;
    return (isolateComponent("li", Object.assign({}, liRole),
        isolateComponent(Tag, Object.assign({}, conditionalProps, { component: isLink ? props.component : undefined, color: isLink ? null : undefined, css: Styles.content(props), href: props.href, onClick: props.onClick, role: props.role }),
            isolateComponent("span", { css: Styles.text }, props.children))));
};
//# sourceMappingURL=MenuItem.js.map
// @zapier/design-system@6.28.0 (14d5b99c8)
